import { Map } from '../../../types'
import { apiRequest } from '../../../services/api'

const createNewMap = (mapId: string, userId: string): Map => {
  return {
    id: mapId,
    name: 'New Floorplan',
    description: '',
    data: {
      elements: [],
      settings: {
        scale: 20, // 20 pixels per foot by default
        units: 'feet',
        gridSize: 20,
        snapToGrid: true,
        showDimensions: true,
        showGrid: true,
        allowDragging: true,
        backgroundPosition: { x: 0, y: 0 },
        backgroundSize: { width: 800, height: 600 },
        backgroundOpacity: 0.5,
        floors: [
          { id: 1, name: 'Ground Floor', elevation: 0, isVisible: true },
        ],
        currentFloor: 1,
      },
    },
    createdAt: new Date(),
    updatedAt: new Date(),
    ownerId: userId,
    isPublic: false,
  }
}

const loadMapFromAPI = async (mapId: string): Promise<Map | null> => {
  try {
    const map = await apiRequest<Map>(`/maps/${mapId}`)
    return map
  } catch (error) {
    console.error('Error loading map from API:', error)
    return null
  }
}

const saveMapToAPI = async (map: Map): Promise<Map> => {
  try {
    const updatedMap = await apiRequest<Map>(`/maps/${map.id}`, {
      method: 'PUT',
      body: JSON.stringify(map),
    })
    return updatedMap
  } catch (error) {
    console.error('Error saving map to API:', error)
    throw error
  }
}

export { loadMapFromAPI, saveMapToAPI }
